import React, { useRef } from 'react';
import './Braces.css';
import braces1 from './Images/Braces/Screenshot 2024-11-28 at 4.00.01 PM.png';
import braces2 from './Images/Braces/Screenshot 2024-11-28 at 4.00.11 PM.png';
import braces3 from './Images/Braces/Screenshot 2024-11-28 at 4.00.18 PM.png';
import braces4 from './Images/Braces/Screenshot 2024-11-28 at 4.00.31 PM.png';
import braces5 from './Images/Braces/Screenshot 2024-11-28 at 4.12.43 PM.png';
import braces6 from './Images/Braces/Screenshot 2024-11-28 at 4.13.08 PM.png';
// import dental4 from '../home/Images/FAP_2141.jpg'
import { Link } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import BookForm from '../book_now/BookForm';
function Braces() {
  const bracesBlogs = [
    {
      id: 1,
      title: "Lingual Braces",
      date: "Aug 7, 2024",
      category: "Cosmetic Dentistry",
      description: "The desire to look good and feel confident about one’s smile is w...",
      content: "Full blog content for Lingual Braces...",
      image: braces1,
    },
    {
      id: 2,
      title: "Conventional Metal Braces",
      date: "Jun 12, 2024",
      category: "Dental Tips",
      description: "Metal braces are known to all and have been in practice since ages....",
      content: "Full blog content for Conventional Metal Braces...",
      image: braces2,
    },
    {
      id: 3,
      title: "Damon Braces",
      date: "Jun 12, 2024",
      category: "Cosmetic Dentistry",
      description: "We all are well aware of the conventional metal braces with its metallic appe...",
      content: "Full blog content for Damon Braces...",
      image: braces3,
    },
    {
      id: 4,
      title: "Ceramic Braces",
      date: "May 24, 2024",
      category: "Dental Tips",
      description: "Want to get braces done but loathing the metallic appearance of it! ...",
      content: "Full blog content for Ceramic Braces...",
      image: braces4,
    },
    {
      id: 5,
      title: "Orthodontics/Braces",
      date: "Apr 8, 2024",
      category: "Cosmetic Dentistry",
      description: "Are you looking for the best dental treatment to correct your misaligned teet...",
      content: "Full blog content for Orthodontics/Braces...",
      image: braces5,
    },
    {
      id: 6,
      title: "Clear Aligners",
      date: "Apr 8, 2024",
      category: "Cosmetic Dentistry",
      description: "Discover how clear aligners can transform your smile without visible braces...",
      content: "Full blog content for Clear Aligners...",
      image: braces6,
    },
  ];
 const bookFormRef = useRef(null);

 // Function to handle smooth scrolling
 const scrollToBookForm = (e) => {
   e.preventDefault();
   bookFormRef.current?.scrollIntoView({
     behavior: "smooth",
     block: "start",
   });
 };
  return (
    <div className='braces'>
      <section className="braces-sec1">
        <div className="content3">
          <div className="text-section">
            <p className="trusted-text"><mark className='domark'>SERVICE OF BOMBAY DENTAL CLINIC</mark></p>
            <h1 className="exceptional"><mark className='expmrk'>Achieve a </mark></h1>
            <h1 className="exceptional"><mark className='expmrk'>Straighter,</mark></h1>
            <h1 className="exceptional"><mark className='expmrk'>Healthier Smile</mark></h1>
            <a onClick={scrollToBookForm} ><button className="book-button">BOOK ONLINE</button></a>
            <p className="call-text">OR CALL <a href="tel:+918882672980">088826 72980</a></p>
            {/* <p className="call-text2">9582474046</p> */}
          </div>
        </div>
      </section>
      <div className="blog-section-container">
        <h1 className="blog-section-heading">Braces</h1>
        <div className="blog-cards-container">
          {bracesBlogs.map((blog) => (
            <div key={blog.id} className="blog-card">
              <img src={blog.image} alt={blog.title} className="blog-image" />
              <div className="blog-details">
                <h2 className="blog-title">{blog.title}</h2>
                <p className="blog-meta">{blog.date} | {blog.category}</p>
                <p className="blog-description">{blog.description}</p>
                <Link to={`/braces/${blog.id}`} className="read-more-button">Read More</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
     
    <div className="home-sec8">
    <div className="book-visit-container">
      <div className="online">
        <h1 className='book'>Book your visit online</h1>
        <p className='view'>Book your visit online and enjoy our unique No-wait policy, so that you have time for what you enjoy, and not spend your precious time in the doctor’s waiting area.
         A few lucky callers every month will be randomly shortlisted for a free scaling and polishing session.</p>
      </div>
    </div>
    </div> 
    <div ref={bookFormRef}>

    <BookForm/>
    </div>
    </div>
  );
}

export default Braces;
